export default "__VITE_ASSET__BOTZNLCZ__"